export default __webpack_public_path__ + "static/media/daily.78aaaf21.svg";